import React, { useMemo, useState } from "react";
import { Segmented } from "antd";
import { getUser } from "../../../../utils/helpers";
import { canAccessDataOpsRca } from "../utils/rcaUtils";
import RcaTab from "./RcaTab";
import DataOpsRcaTrackingTab from "./DataOpsRcaTrackingTab";
import "../DataOpsAnalytics.css";

const SUB_VIEW = {
  ANALYTICS: "Analytics",
  RCA: "RCA",
};

/**
 * Data Ops → RCA: Upload/History-style toggle between Analytics dashboard and RCA tracking.
 */
export default function DataOpsRcaHubTab() {
  const user = useMemo(() => getUser(), []);
  const canViewRcaHub = canAccessDataOpsRca(user?.permissionMap);

  const availableViews = useMemo(() => (
    canViewRcaHub ? [SUB_VIEW.ANALYTICS, SUB_VIEW.RCA] : []
  ), [canViewRcaHub]);

  const [activeView, setActiveView] = useState(
    () => availableViews[0] || SUB_VIEW.ANALYTICS,
  );

  const segmentedValue = availableViews.includes(activeView)
    ? activeView
    : availableViews[0];

  if (availableViews.length === 0) {
    return null;
  }

  return (
    <div className="DataOpsAnalytics DataOpsRcaHub">
      {availableViews.length > 1 && (
        <Segmented
          block
          className="CustomSegmented"
          value={segmentedValue}
          onChange={setActiveView}
          options={availableViews.map((view) => ({ value: view, label: view }))}
        />
      )}
      {segmentedValue === SUB_VIEW.ANALYTICS && canViewRcaHub && <RcaTab embedded />}
      {segmentedValue === SUB_VIEW.RCA && canViewRcaHub && <DataOpsRcaTrackingTab embedded />}
    </div>
  );
}
